export const trailPinActiveImageName = 'trail-pin-active';
export const trailPinCollapsedImageName = 'trail-pin-collapsed';
export const trailPinCollapsedClosedImageName = 'trail-pin-collapsed-closed';
export const trailPinCollapsedSavedImageName = 'trail-pin-collapsed-saved';
export const trailPinCollapsedCompletedImageName = 'trail-pin-collapsed-completed';
export const trailPinCollapsedViewedImageName = 'trail-pin-collapsed-viewed';
export const trailPinCollapsedPriorityHighImageName = 'trail-pin-collapsed-priority-high';
export const trailPinCollapsedPriorityMediumImageName = 'trail-pin-collapsed-priority-medium';
export const trailPinCollapsedPriorityLowImageName = 'trail-pin-collapsed-priority-low';
export const isTrailClosedExpression = ['==', ['get', 'isClosed'], true];
export const isTrailSavedExpression = ['==', ['get', 'isSaved'], true];
export const isTrailCompletedExpression = ['==', ['get', 'isCompleted'], true];
export const isTrailCollapsedExpression = ['==', ['get', 'isCollapsed'], true];
export const isTrailPriorityHighExpression = ['==', ['get', 'priority'], 'high'];
export const isTrailPriorityMediumExpression = ['==', ['get', 'priority'], 'medium'];
export const isTrailPriorityLowExpression = ['==', ['get', 'priority'], 'low'];
export const isTrailHasPriorityExpression = ['any', isTrailPriorityHighExpression, isTrailPriorityMediumExpression, isTrailPriorityLowExpression];
